

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( ){

		var _this = this , i ;

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// この中に処理を書いていってください。

		// var monstNews__bgLayer = document.getElementsByClassName("monstNews__bgLayer")[0];
		// monstNews__bgLayer.css = new ResponsiveCSS( ".monstNews__bgLayer" ) ;

		// ScrollEnterEvent.add( monstNews__bgLayer, {
		// 	autoRemove:false,
		// 	onInside:function(evt){
		// 		monstNews__bgLayer.css.sp.y = -140 + 200 * evt.position ;
		// 		monstNews__bgLayer.css.pc.y = -180 + 800 * evt.position ;
		// 		monstNews__bgLayer.css.update();
		// } } ) ;


		var footerApp__bgLayer = document.getElementsByClassName("footerApp__bgLayer")[0];
		footerApp__bgLayer.css = new ResponsiveCSS( ".footerApp__bgLayer" ) ;

		ScrollEnterEvent.add( footerApp__bgLayer, {
			autoRemove:false,
			onInside:function(evt){
				footerApp__bgLayer.css.sp.y = -125 + 170 * evt.position ;
				footerApp__bgLayer.css.update();
		} } ) ;


		var campaignInfo__bgLayer = document.getElementsByClassName("campaignInfo__bgLayer")[0];
		campaignInfo__bgLayer.css = new ResponsiveCSS( ".campaignInfo__bgLayer" ) ;

		ScrollEnterEvent.add( campaignInfo__bgLayer, {
			autoRemove:false,
			onInside:function(evt){
				campaignInfo__bgLayer.css.sp.y = 150 * evt.position - 80;
				campaignInfo__bgLayer.css.pc.y = 300 * evt.position - 160;
				campaignInfo__bgLayer.css.update();
		} } ) ;

		new Campaign();
		new Character();
		new Movie();

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		// {

		// }

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;


		// var client = new XMLHttpRequest();
		// client.onreadystatechange = function(evt) {

		// 	if( this.readyState == this.HEADERS_RECEIVED ) {
		// 		try {
		// 			var date_str = client.getResponseHeader("Date").replace(/GMT/gi, "");
		// 			serverDate = new Date(date_str);
		// 		}catch(err) {
		// 			date_str = null;
		// 			serverDate = new Date();
		// 		}

		// 		if(date_str) {
		// 			serverDate.setHours(serverDate.getHours()+9) ;
		// 		}
		// 		serverTime = serverDate.getTime();

		// 		// 以下から必要な記述を書いてください
		// 		//console.log(serverDate);
		// 	}
		// }
		// client.open("GET", "//get-date-for-site.s3-ap-northeast-1.amazonaws.com/index.html?" + new Date().getTime(), true);
		// client.send();

		// new ServerTime( function(evt){
		// 	console.log( evt.date );
		// } ) ;

	}



//------------------------------------------------------------------------------------------------------------------------------


	var Campaign = function() {
		var _this = this, i;
		var _animTarget = [];

		_animTarget[0] = document.getElementsByClassName("campaignInfo__content")[0];
		_animTarget[0].defClassName = _animTarget[0].className;
		_animTarget[1] = document.getElementsByClassName("step1__content")[0];
		_animTarget[1].defClassName = _animTarget[1].className;

		ScrollEnterEvent.add(
			_animTarget,
			{
				onEnter:function( evt ){
					evt.target.className = evt.target.defClassName + " effect";
				},
				// onExit:function( evt ){
				// 	evt.target.className = evt.target.defClassName + " effect disable" ;
				// },
				marginScale: 0.3,
				autoRemove: false
			}
		) ;


	}


//------------------------------------------------------------------------------------------------------------------------------


	var Character = function(){

		var _this = this, i;
		var _root = document.getElementsByTagName("character")[0];


		//---------------------------------------------------------
		//サムネールナビの機能実装
		var charListNav = document.getElementsByClassName("charListNav")[0];
		charListNav_button = charListNav.getElementsByTagName("button");
		charListNav_button.slideIndex = [1, 4, 6, 8, 10] ;
		charListNav_button.fucus = charListNav_button[0] ;
		charListNav_button.fucus.className = charListNav_button.fucus.className + " focus";
		charListNav_button.onEvent = function(evt){
			switch(evt.type){
				case "click" :
					$charaList.slick("slickSetOption","speed",550);
					$charaList.slick("slickSetOption","cssEase",'cubic-bezier(0.77, 0, 0.175, 1)');
					$charaList.slick("slickGoTo", evt.target.slideIndex);
					break ;
			}
		}
		for( i = 0 ; i < charListNav_button.length ; i++ ) {
			charListNav_button[i].slideIndex = charListNav_button.slideIndex[i];
			charListNav_button[i].addEventListener("click", charListNav_button.onEvent);
		}


		//---------------------------------------------------------
		//スライド下のドット
		var charPageNav = document.getElementsByClassName("charPageNav")[0];
		charPageNav_button = charPageNav.getElementsByTagName("button");
		charPageNav_button.dotIndex = 1 ;
		charPageNav_button.fucus = charPageNav_button[charPageNav_button.dotIndex];
		charPageNav_button.fucus.className = charPageNav_button.fucus.className + " focus";
		charPageNav_button.onEvent = function(evt){
			switch(evt.type){
				case "click" :
					$charaList.slick("slickGoTo", $charaList.shinkamaeIndex[$charaList.charIndex]+evt.target.dotIndex);
					break ;
			}
		}
		for( i = 0 ; i < charPageNav_button.length ; i++ ) {
			charPageNav_button[i].dotIndex = i ;
			charPageNav_button[i].addEventListener("click", charPageNav_button.onEvent);
		}


		//---------------------------------------------------------
		//スライドのslick実装
		var slickInitObj = {
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			initialSlide: 1,
			dots: false,
			autoplay: false,
			autoplaySpeed: 5000,
			swipeToSlide: true,
			cssEase: 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
			speed: 400
		};

		var $charaList = $(document.getElementsByClassName( 'charDetailSlide' )[0]);
		$charaList.slick( slickInitObj );
		$charaList.currentIndex = 1;
		$charaList.charIndex = 0;
		$charaList.shinkamaeIndex = [0, 3, 5, 7, 9];
		$charaList.on('beforeChange', function(event, slick, currentSlide, nextSlide) {

			//サムネールのフォーカス設置
			switch( nextSlide % 11 ){
				case 0 :
				case 1 :
				case 2 :
					$charaList.charIndex = 0;
					characterDetail__toHowtoGet.href = "#howto-get-doraemon";
					break;

				case 3 :
				case 4 :
					$charaList.charIndex = 1;
					characterDetail__toHowtoGet.href = "#howto-get-other";
					break;

				case 5 :
				case 6 :
					$charaList.charIndex = 2;
					characterDetail__toHowtoGet.href = "#howto-get-shizuka";
					break;

				case 7 :
				case 8 :
					$charaList.charIndex = 3;
					characterDetail__toHowtoGet.href = "#howto-get-other";
					break;

				case 9 :
				case 10 :
					$charaList.charIndex = 4;
					characterDetail__toHowtoGet.href = "#howto-get-other";
					break;
			}

			var nextTarget = charListNav_button[$charaList.charIndex] ;

			if( nextTarget != charListNav_button.fucus ){
				charListNav_button.fucus.className = charListNav_button.fucus.className.replace( /\sfocus/ , "" );
				charListNav_button.fucus = nextTarget;
				charListNav_button.fucus.className = charListNav_button.fucus.className + " focus";
			}


			//ドットのフォーカス位置について
			if( nextSlide % 11 <= 2 ){
				charPageNav_button[2].style.display = "";
			}else {
				charPageNav_button[2].style.display = "none";
			}
			switch( nextSlide % 11 ){
				case 0 :
				case 3 :
				case 5 :
				case 7 :
				case 9 :
					charPageNav_button.dotIndex = 0;
					break;

				case 1 :
				case 4 :
				case 6 :
				case 8 :
				case 10 :
					charPageNav_button.dotIndex = 1;
					break;

				case 2 :
					charPageNav_button.dotIndex = 2;
					break;
			}
			charPageNav_button.fucus.className = charPageNav_button.fucus.className.replace( /\sfocus/ , "" );
			charPageNav_button.fucus = charPageNav_button[charPageNav_button.dotIndex];
			charPageNav_button.fucus.className = charPageNav_button.fucus.className + " focus";
		} ) ;
		//サムネールでキャラ遷移したときだけ、別のイージングを設定するので、それの解除を行う
		$charaList.on('afterChange', function(event, slick, currentSlide) {
			$charaList.slick("slickSetOption","speed",400);
			$charaList.slick("slickSetOption","cssEase",'cubic-bezier(0.215, 0.610, 0.355, 1.000)');
		} ) ;


		//---------------------------------------------------------
		//キャラクター入手方法のアンカー
		//スライドの表示キャラによってアンカー先を変えるために使用
		var characterDetail__toHowtoGet = document.getElementsByClassName("characterDetail__toHowtoGet")[0];


		//---------------------------------------------------------
		//背景画像のパララックス
		var character = document.getElementsByClassName("character__content")[0];
		var character__bgLayer = document.getElementsByClassName("character__bgLayer")[0];
		character__bgLayer.css = new ResponsiveCSS( ".character__bgLayer" );

		ScrollEnterEvent.add( character, {
			autoRemove:false,
			onInside:function(evt){
				character__bgLayer.css.sp.y = -300 + 800 * evt.position;
				character__bgLayer.css.pc.y = -300 + 800 * evt.position;
				character__bgLayer.css.update();
		} } ) ;
	};


//------------------------------------------------------------------------------------------------------------------------------


	var Movie = function(){

		var _this = this, i;

		var slickInitObj = {
			arrows: false,
			centerMode: true,
			variableWidth: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			initialSlide: 0,
			dots: true,
			autoplay: false,
			autoplaySpeed: 5000,
			swipeToSlide: true,
			cssEase: 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
			speed: 400
		};

		var $movieList = $(document.getElementsByClassName( 'movieList' )[0]);
		$movieList.slick( slickInitObj );
	};


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function(func){ return setTimeout( func, 1000/60 ); };


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function(id){ clearTimeout(id); };


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;

